// extracted by mini-css-extract-plugin
module.exports = {"windMap":"wind-map_windMap__3Msgw","fps":"wind-map_fps__-cCWc"};